var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { AnchorButton, Button, PhoneTextField, TextField, } from "@savvyinsure/react-ui";
import AppBody from "../components/AppBody";
import ConsentFooter from "../components/ConsentFooter";
import { EMAIL } from "../utils/regexLibrary";
import Header from "../components/Header";
import Image from "../components/Image";
import { PHASE } from "../routeConfig";
import RouteHeaderLogo from "../components/RouteHeaderLogo";
import RouteTitle from "../components/RouteTitle";
import { completedPage } from "../lib/Avo";
import { savePolicyHolder } from "../features/unlinked-application/unlinkedApplicationSlice";
import useAffiliateConfig from "../hooks/useAffiliateConfig";
import useAppDispatch from "../hooks/useAppDispatch";
import useAppSelector from "../hooks/useAppSelector";
import { useForm } from "react-hook-form";
import useMemoryHistory from "../hooks/useMemoryHistory";
import { useUpdateAccountInfoMutation } from "../services/savvy";
import { validatePhone } from "../features/unlinked-application/validateUnlinkedPolicyHolderData";
var consentButtonText = "Agree & Continue";
var titleText = "Import Successful";
var nextRoute = PHASE.QUOTE_LOADING;
export default function VerifyContactRoute() {
    var _a, _b;
    var push = useMemoryHistory().push;
    var _c = useUpdateAccountInfoMutation(), updateAccountInfo = _c[0], isLoading = _c[1].isLoading;
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _d = useAppSelector(function (state) { return state.applicant; }), accountReferenceId = _d.accountReferenceId, jornayaLeadId = _d.jornayaLeadId.savvy;
    var _e = useAppSelector(function (state) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var policy = state.applicant.accountLinked.home
            ? (_a = state.policies.home) === null || _a === void 0 ? void 0 : _a[0]
            : (_b = state.policies.auto) === null || _b === void 0 ? void 0 : _b[0];
        var unlinkedPolicyHolder = state.unlinkedApplication.policyHolder;
        return {
            email: (_e = (_d = (_c = policy === null || policy === void 0 ? void 0 : policy.policyHolder) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : unlinkedPolicyHolder.email) !== null && _e !== void 0 ? _e : "",
            phoneNumber: (_h = (_g = (_f = policy === null || policy === void 0 ? void 0 : policy.policyHolder) === null || _f === void 0 ? void 0 : _f.phoneNumber) !== null && _g !== void 0 ? _g : unlinkedPolicyHolder.phone) !== null && _h !== void 0 ? _h : "",
            isUnlinked: !state.applicant.accountLinked.auto &&
                !state.applicant.accountLinked.home,
        };
    }), email = _e.email, phoneNumber = _e.phoneNumber, isUnlinked = _e.isUnlinked;
    var affiliateConfig = useAffiliateConfig();
    var dispatch = useAppDispatch();
    var values = {
        email: email,
        phone: phoneNumber,
    };
    var _f = useForm({
        defaultValues: values,
        values: values,
        mode: "all",
    }), register = _f.register, handleSubmit = _f.handleSubmit, _g = _f.formState, errors = _g.errors, isValid = _g.isValid;
    var phoneInput = register("phone", {
        required: "Please enter a valid US phone number",
        validate: {
            isValid: function (value) {
                return validatePhone(value, { required: false }) ||
                    "Please enter a valid US phone number";
            },
        },
    });
    var submitHanlder = handleSubmit(function (contactDetails, event) {
        event === null || event === void 0 ? void 0 : event.preventDefault();
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: consentButtonText, optionSelected: consentButtonText }));
        if (isUnlinked) {
            dispatch(savePolicyHolder({
                email: contactDetails.email,
                phone: contactDetails.phone,
            }));
        }
        if (accountReferenceId) {
            updateAccountInfo({
                accountReferenceId: accountReferenceId,
                contactDetails: contactDetails,
                jornayaLeadId: jornayaLeadId,
            })
                .unwrap()
                .then(function () {
                push(nextRoute);
            });
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null,
            React.createElement(RouteHeaderLogo, null)),
        React.createElement(AppBody, { as: "form", onSubmit: submitHanlder },
            React.createElement("div", { className: "flex grow flex-col overflow-y-scroll" },
                React.createElement("div", { className: "mx-auto mb-6 flex items-center justify-center" },
                    React.createElement(Image, { src: "/assets/icons/green-checkmark.svg", width: 48, height: 48, alt: "" })),
                React.createElement(RouteTitle, { className: "text-center font-bold sm:mb-2" }, titleText),
                React.createElement("p", { className: "mb-4 text-center text-base leading-5 text-black-300" }, "Please verify your contact information."),
                React.createElement("div", { className: "space-y-3 px-4 pb-4 md:px-6" },
                    React.createElement("div", null,
                        React.createElement(PhoneTextField, { id: "phone", label: "Mobile Number", type: "tel", format: "(###) ###-####", defaultValue: phoneNumber, mask: "", onBlur: phoneInput.onBlur, onChange: phoneInput.onChange, name: phoneInput.name, getInputRef: phoneInput.ref, "aria-invalid": Boolean(errors.phone), errorMessage: (_a = errors.phone) === null || _a === void 0 ? void 0 : _a.message })),
                    React.createElement(TextField, __assign({ label: "Email Address", type: "email" }, register("email", {
                        required: "Please enter a valid email address",
                        validate: {
                            isValid: function (value) {
                                return (typeof value === "string" && EMAIL.test(value)) ||
                                    "Please enter a valid email address";
                            },
                        },
                    }), { "aria-invalid": Boolean(errors.email), errorMessage: (_b = errors.email) === null || _b === void 0 ? void 0 : _b.message })))),
            React.createElement(ConsentFooter, null,
                affiliateConfig.agentsAvailable ? (React.createElement(AnchorButton, { variant: "outlined", className: "px-3 text-sm md:px-4 md:text-base", style: { width: "auto" }, href: "tel:+".concat(affiliateConfig.helpPhoneNumber), target: "_parent", onClick: function (ev) {
                        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
                    } }, "Call Now")) : null,
                React.createElement(Button, { className: "flex-1 text-sm md:ml-4 md:text-base", type: "submit", disabled: !isValid || isLoading }, isLoading ? "Saving..." : "Agree & Continue")))));
}
